exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-panel .main-loading {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}", ""]);

// exports
